import { defineMessages } from 'react-intl';

const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dependencyTypeBlocks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.add-dependency.card-title',
		defaultMessage: 'Add plan dependency',
		description: 'Title for the add plan dependency action card',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.add-dependency.confirm-button',
		defaultMessage: 'Add',
		description:
			'Text on the confirm button in the Jira Plans add dependency dialog. Clicking it submits the form and creates the specified dependency between work items',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.add-dependency.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Text on the cancel button in the Jira Plans add dependency dialog. Dismisses the dialog without saving any changes',
	},
	dependencyTypeBlocks: {
		id: 'conversation-assistant-message-actions.add-dependency.dependency-type-blocks',
		defaultMessage: 'blocks',
		description: 'Default label for the dependency type when not provided',
	},
});

export default messages;
